import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["distance"];
import styled from 'styled-components';
import { toShorthandSize } from '../../utils/tShirtSizes';
import { DISTANCE_SIZES } from '../../utils/distance';
import { jsx as _jsx } from "react/jsx-runtime";
const StyledHR = styled.hr.withConfig({
  displayName: "HR__StyledHR",
  componentId: "sc-17dv8v0-0"
})(({
  $distance,
  theme: _theme
}) => {
  const theme = _theme;
  return {
    border: theme.borderWidth['0'],
    height: theme.space['25'],
    backgroundColor: theme.color['border-primary-default'],
    /* Set min-height and width so that it will never be shrunk inside a flex container */
    minHeight: theme.space['25'],
    width: '100%',
    marginBlock: theme.space[DISTANCE_SIZES[toShorthandSize($distance)]]
  };
});
export const HR = _ref => {
  let {
      distance = 'md'
    } = _ref,
    rest = _objectWithoutPropertiesLoose(_ref, _excluded);
  return /*#__PURE__*/_jsx(StyledHR, Object.assign({}, rest, {
    $distance: distance
  }));
};